import { useState, type FormEvent } from 'react';
import { useSession } from '../auth/session.js';
import { Brand } from './setup.js';

export const LoginRoute = () => {
  const { login } = useSession();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setBusy(true); setError(null);
    try { await login(String(data.get('email') ?? ''), String(data.get('password') ?? '')); }
    catch { setError('Credenciais inválidas. Confira os dados e tente novamente.'); }
    finally { setBusy(false); }
  };
  return <main className="auth-stage">
    <section className="auth-sheet" aria-labelledby="login-title">
      <Brand />
      <h1 id="login-title">Entrar</h1>
      <p>Acesse a operação de WhatsApp Cloud da DreamTech.</p>
      <form onSubmit={(event) => void submit(event)}>
        <label htmlFor="login-email">E-mail</label>
        <input id="login-email" name="email" type="email" autoComplete="username" required aria-describedby={error === null ? undefined : 'login-error'} />
        <label htmlFor="login-password">Senha</label>
        <input id="login-password" name="password" type="password" autoComplete="current-password" required aria-describedby={error === null ? undefined : 'login-error'} />
        <button type="submit" disabled={busy}>{busy ? 'Entrando…' : 'Entrar'}</button>
      </form>
      {error === null ? null : <p id="login-error" role="alert" className="form-error">{error}</p>}
    </section>
  </main>;
};
